<template>
  <div>
    <div id="login" class="d-flex justify-content-center align-items-center">
      <div class="d-flex flex-wrap justify-content-center">
        <figure class="text-center mb-0 mx-5">
          <img src="../../assets/paginaoficial/Logotipo_Negativo_Vertical.png" alt="Logo de Poder Judicial del Estado de Aguascalientes" />
        </figure>
        <h3 id="tituloDelInicioDeSesion" class="w-100"></h3>
        <div id="datosParaIniciarSesion" class="">
          <div class="form-group position-relative">
            <input type="email" class="form-control" placeholder="Usuario" v-model="correoElectronico"  v-on:keyup.enter="iniciarSesion()">
            <i class="fas fa-user"></i>
          </div>
          <div class="form-group position-relative">
            <input type="password" class="form-control" placeholder="Contraseña" v-model="contrasena" v-on:keyup.enter="iniciarSesion()">
            <i class="fas fa-lock"></i>
          </div>
          <button class="btn w-100 py-2 mt-4 overwrapDeBotones" v-on:click="iniciarSesion()">
            ENTRAR
          </button>
        </div>
        <div id="iniciandoSesion" class="w-100 py-2 mt-4 justify-content-center text-center position-relative d-none">
          <i class="fas fa-spinner fa-spin fa-5x" style="left: 0; right: 0"></i>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
  import comun from '@/../static/js/comun'
  import { mapActions } from 'vuex'

  export default {
    data() {
      return {
        correoElectronico: "",
        contrasena: ""
      }
    },
    beforeMount() {
      
    },
    mounted() {
      /* VAMOS A REALIZAR PRUEBAS DE PERFORMANCE PARA EQUIPOS VIEJOS POR ESO ESTA COMENTADO ESTAS LINEAS
      VANTA.NET({
        el: "#login",
        backgroundColor: 0x111111,
        maxDistance: 20.00,
        color: 0xffffff,
        points: 10.00,
        spacing: 16.00
      });*/

      if(this.$store.state.TiempoDeVerificacionId != null) {
        clearInterval(this.$store.state.TiempoDeVerificacionId);
        this.$store.state.TiempoDeVerificacionId = null;
      }

      comun.SeEstaIniciandoSesion(false);
    },
    methods: {
      iniciarSesion: function() {
        let parametros = {
          CorreoElectronico: this.correoElectronico,
          Contrasena: this.contrasena
        };

        this.A_IniciarYCrearLaSesionEnLocalStorage(parametros);
      },
      ...mapActions([
        'A_IniciarYCrearLaSesionEnLocalStorage',
        'A_ValidaSesionObtenDatosGeneralesObtenPermisosDelSistema'
      ])
    }
  }
</script>


<style scoped>
  #login {
    width: 100vw;
    height: 100vh;
  }

    #login > div {
      background-color: rgb(0,117,115);
      width: 460px;
      height: 600px;
      border-radius: 8px;
      align-content: center;
    }

    #login form {
      width: 70%;
    }

    #login img {
      width: 70%;
    }

  h3 {
    color: #FFFFFF;
    text-align: center;
    margin-bottom: 4vh;
    margin-top: 3vh;
  }

  i {
    position: absolute;
    top: 10px;
    left: 10px;
  }

  input {
    padding-left: 35px;
  }

  button {
    font-weight: bold;
    transition: all .25s;
    background-color: rgb(126,127,116);
    color: #FFFFFF;
  }

    button:hover {
      background-color: #444444;
    }
    
</style>



// WEBPACK FOOTER //
// src/components/Login/Login.vue